query company($companyId: String) {
  company(id: $companyId) {
    id
    country
    landingpages(statuses: [ACTIVE, INACTIVE]) {
      type
      url
      slug
      name
    }
  }
}
